// extracted by mini-css-extract-plugin
module.exports = {"area":"style_area__KyhIf","button":"style_button__3pNSH","open":"style_open__Inn57","new":"style_new__3x5rw","dropdown":"style_dropdown__xwKmy","wrapper":"style_wrapper__Xil0d"};